module.exports = "<div ui-view></div>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/noop-loader!../node_modules/xo-guest-components/src/multistep-signup/template.html
// module id = ../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/template.html
// module chunks = 0